import React, { useCallback, useEffect, useContext } from 'react';
import { InputForm } from './subcomponents/inputForm/InputForm';
import { CheckAvailabilityContext } from '../CheckAvailabilityContext';
import { useCheckAvailability } from '../helpers/useCheckAvailability';
import '../styles/check-availability.scss';

export const ShippingService = () => {
  const {
    onSubmitForm,
    showLoader,
    quantity,
    onError,
    storeId,
    itemId,
    price,
    zip
  } = useContext(CheckAvailabilityContext);

  const [getShipping, { data, loading, error }] = useCheckAvailability();
  const onSubmit = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }
    getShipping({
      variables: {
        itemId,
        storeId,
        zipCode: zip,
        quantity,
        price
      }
    });
  }, [itemId, storeId, zip, quantity, price]);

  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
    if (data && onSubmitForm) {
      onSubmitForm(data);
    }
  }, [data, error, loading]);

  if (loading && showLoader) {
    return (
      <span className="segment-spinner segment-spinner--small" />
    );
  }

  return (
    <div className="check-availability">
      <InputForm onSubmit={onSubmit} />
    </div>
  );
};